import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "88",
  height: "48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 0h88v48H0V0Z",
      fill: "#13161B"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M52.533 26.87a9 9 0 0 1-10.065-11.74A9 9 0 0 0 44 33a9.004 9.004 0 0 0 8.532-6.13Z",
      fill: "#949EAA"
    }, null, -1)
  ])))
}
export default { render: render }